import { SYS_OPACITY_0_PCT, SYS_OPACITY_100_PCT, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_XL, SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_MD, SYS_PAGE_MARGIN_XS } from '@oneaudi/unified-web-common';
import styled, { css } from 'styled-components';
import { IconButton } from '../icon-button/index.js';
const showAnimation = css `
  @keyframes showSmallScreen {
    from {
      opacity: ${SYS_OPACITY_0_PCT};
      transform: translateY(40px);
    }
    to {
      opacity: ${SYS_OPACITY_100_PCT};
      transform: translateY(0);
    }
  }

  animation: showSmallScreen 0.5s ease forwards;

  @keyframes showCustomLargeScreen {
    from {
      opacity: ${SYS_OPACITY_0_PCT};
      transform: translate(-50%, calc(-50% + 40px));
    }
    to {
      opacity: ${SYS_OPACITY_100_PCT};
      transform: translate(-50%, -50%);
    }
  }
`;
export const StyledLayoutContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const StyledInner = styled.div `
  background-color: ${(props) => props.theme.global.color.elevation.level1};
  box-sizing: border-box;
  width: 100%;

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    ${(props) => props.variant === 'focus-small'
    ? css `
            width: ${SYS_BREAKPOINT_MD};
          `
    : css `
            width: ${SYS_BREAKPOINT_LG};
          `}
  }

  ${(props) => props.hasPadding &&
    css `
      padding: 0 ${SYS_PAGE_MARGIN_XS} ${SYS_PAGE_MARGIN_XS}
        ${SYS_PAGE_MARGIN_XS};

      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        display: block;
        padding: ${SYS_PAGE_MARGIN_MD};
      }

      @media (min-width: ${SYS_BREAKPOINT_LG}) {
        padding: ${SYS_PAGE_MARGIN_LG};
      }
    `};
`;
export const StyledOverlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${(props) => props.theme.sem.color.ui.surface.scrim.default};
`;
export const StyledCustomDialog = styled.div `
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  height: fit-content;
  background-color: ${(props) => props.theme.global.color.elevation.level1};
  box-shadow: ${(props) => props.theme.global.boxShadow.elevation.level1};
  border: 0;
  padding: 0;
  box-sizing: border-box;

  ${showAnimation}

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    top: 50%;
    left: 50%;
    animation: showCustomLargeScreen 0.5s ease forwards;

    ${(props) => props.variant === 'alert' &&
    css `
        width: fit-content;
      `};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: fit-content;
  }
`;
export const StyledDialog = styled.dialog `
  box-sizing: border-box;
  box-shadow: ${(props) => props.theme.global.boxShadow.elevation.level1};
  background-color: ${(props) => props.theme.global.color.elevation.level1};
  border: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  inset-block-start: auto;

  ${showAnimation}

  &::backdrop {
    background-color: ${(props) => props.theme.sem.color.ui.surface.scrim.default};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    inset-block-start: revert;

    ${(props) => props.variant === 'alert' &&
    css `
        width: fit-content;
      `}
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: fit-content;
  }
`;
export const StyledIconButton = styled(IconButton) `
  align-self: flex-end;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    position: absolute;
    top: 0;
    right: 0;
  }
`;
export const StyledAlert = styled.div `
  box-sizing: border-box;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: 600px; // No token available in Figma
  }

  ${(props) => props.hasPadding &&
    css `
      padding: ${SYS_PAGE_MARGIN_XS};

      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        padding: ${SYS_PAGE_MARGIN_MD};
      }

      @media (min-width: ${SYS_BREAKPOINT_LG}) {
        padding: ${SYS_PAGE_MARGIN_LG};
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map